import { useState } from 'react'
import { DownArrowIcon, ToggleDisableIcon, ToggleEnableIcon } from '~/components/icons'
import classNames from 'classnames'

type cookieHandleProps = {
  handleToggle: (cookieType: string) => void
  CookieConsent: Array<string>
}
export const CookieTypes = ({ CookieConsent, handleToggle }: cookieHandleProps) => {
  const [openEssential, setOpenEssential] = useState(false)
  const [openAnalytical, setOpenAnalytical] = useState(false)
  const [openTargeting, setOpenTargeting] = useState(false)

  return (
    <div className="flex flex-col items-start p-0 gap-2 h-auto flex-none flex-grow-0 self-stretch w-[680px] max-lg:w-[664px] max-md:w-auto">
      <div
        className={classNames(
          'flex flex-col items-start p-5 h-auto w-[680px] flex-none order-0 flex-grow-0 self-stretch rounded-2xl bg-neutral-5 max-lg:w-[664px] max-md:p-3 max-md:w-auto',
          {
            'gap-4 max-md:gap-3': openEssential,
          },
        )}
      >
        <div className="flex justify-between items-center flex-none self-stretch flex-grow-0 p-0 gap-3 h-12 w-[640px] max-lg:w-[624px] max-lg:h-6 max-md:w-auto">
          <div
            className="flex p-0 gap-1 items-start min-w-[194px] h-auto flex-none order-none flex-grow-0 cursor-pointer max-lg:min-w-[170px]"
            onClick={() => setOpenEssential((pre: boolean) => !pre)}
          >
            <button className="w-7 h-7 border-none order-0 flex-grow-0 cursor-pointer bg-transparent max-lg:w-6 max-lg:h-6">
              <DownArrowIcon
                className={classNames('top-3 left-5 text-black h-3 w-[10px', {
                  'rotate-180 transition-all duration-300 ease-linear': openEssential,
                })}
              />
            </button>
            <p className="text-s text-neutral-100">Essential cookies</p>
          </div>
          <p className="font-tt_talent text-xs max-md:text-mobile-s text-neutral-50 flex-grow-0 text-right flex-none order-1 max-md:h-5 max-lg:h-6 max-lg:w-25">
            Always active
          </p>
        </div>

        {openEssential && (
          <>
            <p
              className="h-36 max-lg:h-30 max-md:h-55 text-mobile-s font-tt_talent max-md:text-mobile-xs max-md:w-auto flex-grow-0 self-stretch flex-none text-neutral-100 max-w-[640px]"
              style={{ transition: 'height 0.4s,opacity 0.3s' }}
            >
              These cookies are necessary for the correct functioning of the website and cannot be
              switched off by our systems. These cookies are generally only set in response to
              actions undertaken by you which correspond to service requests, such as defining your
              data protection settings, registering or filling in forms. You can change your browser
              settings to deactivate these cookies, but this can impede access and use of the
              website.
            </p>

            <a
              className="h-6 max-md:h-5font-tt_talent text-s text-mobile-s max-md:text-mobile-xs flex-none flex-grow-0 text-blue-50 w-[330px]"
              style={{ transition: 'height 0.4s,opacity 0.6s' }}
              rel="noreferrer"
              href="https://career.io/cookie-policy"
              target="_blank"
            >
              Find out more
            </a>
          </>
        )}
      </div>
      <div
        className={classNames(
          'flex flex-col items-start p-5 h-auto w-[680px] flex-none order-0 flex-grow-0 self-stretch rounded-2xl bg-neutral-5 max-lg:w-[664px] max-md:p-3 max-md:w-auto',
          {
            'gap-4 max-md:gap-3': openAnalytical,
          },
        )}
      >
        <div className="flex justify-between items-center flex-none self-stretch flex-grow-0 p-0 gap-3 h-12 w-[640px] max-lg:w-[624px] max-lg:h-6 max-md:w-auto">
          <div
            className="flex p-0 gap-1 items-start min-w-[194px] h-auto flex-none order-none flex-grow-0 cursor-pointer max-lg:min-w-[170px]"
            onClick={() => setOpenAnalytical((pre: boolean) => !pre)}
          >
            <button className="w-7 h-7 border-none order-0 flex-grow-0 cursor-pointer bg-transparent max-lg:w-6 max-lg:h-6">
              <DownArrowIcon
                className={classNames('top-3 left-5 text-black h-3 w-[10px', {
                  'rotate-180 transition-all duration-300 ease-linear': openAnalytical,
                })}
              />
            </button>
            <p className="text-s text-neutral-100">Analytical cookies</p>
          </div>
          {CookieConsent.includes('AnalyticalCookies') ? (
            <ToggleEnableIcon onClick={() => handleToggle('analytical')} />
          ) : (
            <ToggleDisableIcon onClick={() => handleToggle('analytical')} />
          )}
        </div>
        {openAnalytical && (
          <>
            <p
              className="opacity-100 h-36 max-lg:h-30 max-md:h-55 text-mobile-s font-tt_talent max-md:text-mobile-xs max-md:w-auto flex-grow-0 self-stretch flex-none text-neutral-100 max-w-[640px]"
              style={{ transition: 'height 0.4s,opacity 0.3s' }}
            >
              These cookies enable us to count visits and origins of accesses so that we can
              evaluate and improve the services on our website. They help us to understand which
              pages are the most popular, which are the least visited, and how visitors navigate
              around our site. If you do not allow these cookies, we will not know when you have
              visited our website.
            </p>
            <a
              className="h-6 max-md:h-5 font-tt_talent text-s text-mobile-s max-md:text-mobile-xs flex-none flex-grow-0  text-blue-50 w-[330px]"
              href="https://career.io/cookie-policy"
              target="_blank"
              rel="noreferrer"
            >
              Find out more
            </a>
          </>
        )}
      </div>
      <div
        className={classNames(
          'flex flex-col items-start p-5 h-auto w-[680px] flex-none order-0 flex-grow-0 self-stretch rounded-2xl bg-neutral-5 max-lg:w-[664px] max-md:p-3 max-md:w-auto',
          {
            'gap-4 max-md:gap-3': openTargeting,
          },
        )}
      >
        <div className="flex justify-between items-center flex-none self-stretch flex-grow-0 p-0 gap-3 h-12 w-[640px] max-lg:w-[624px] max-lg:h-6 max-md:w-auto">
          <div
            className="flex p-0 gap-1 items-start min-w-[194px] h-auto flex-none order-none flex-grow-0 cursor-pointer max-lg:min-w-[170px]"
            onClick={() => setOpenTargeting((pre: boolean) => !pre)}
          >
            <button className="w-7 h-7 border-none order-0 flex-grow-0 cursor-pointer bg-transparent max-lg:w-6 max-lg:h-6">
              <DownArrowIcon
                className={classNames('top-3 left-5 text-black h-3 w-[10px', {
                  'rotate-180 transition-all duration-300 ease-linear': openTargeting,
                })}
              />
            </button>
            <p className="text-s text-neutral-100">Marketing and tracking cookies</p>
          </div>
          {CookieConsent.includes('TargetingCookies') ? (
            <ToggleEnableIcon onClick={() => handleToggle('targeting')} />
          ) : (
            <ToggleDisableIcon onClick={() => handleToggle('targeting')} />
          )}
        </div>
        {openTargeting && (
          <>
            <p
              className="h-36 max-lg:h-30 max-md:h-55 text-mobile-s font-tt_talent max-md:text-mobile-xs max-md:w-auto  flex-grow-0 self-stretch flex-none text-neutral-100 max-w-[640px]"
              style={{ transition: 'height 0.4s,opacity 0.3s' }}
            >
              These cookies may be set through our site by us (first-party cookies) or our
              advertising partners (third-party cookies). They may be used by us and those companies
              to build a profile of your interests and show you relevant adverts on other sites. If
              you do not allow these cookies, you will experience less targeted advertising.
            </p>
            <a
              className="h-6 max-md:h-5 font-tt_talent text-s text-mobile-s max-md:text-mobile-xs flex-none flex-grow-0 text-blue-50 w-[330px]"
              rel="noreferrer"
              href="https://career.io/cookie-policy"
              target="_blank"
            >
              Find out more
            </a>
          </>
        )}
      </div>
    </div>
  )
}
